(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["opiniones"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.svtpReady) return;
      root.dataset.svtpReady = '1';
      var section = root.closest('.svtp');
      var track = root.querySelector('.svtp__track');
      if (!track) return;
      var dots = root.querySelector('.svtp__dots');
      var prev = root.querySelector('.svtp__prev');
      var next = root.querySelector('.svtp__next');
      var loop = root.dataset.loop === 'true';
      var auto = root.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var ms = Math.max(1, parseFloat(root.dataset.speed) || 5) * 1000;
      var timer = null;
      var paused = false;
      var scrollT = null;

      function slides() { return track.children; }
      function scrollable() {
        return getComputedStyle(track).display === 'flex' && track.scrollWidth > track.clientWidth + 2;
      }
      function step() {
        var s = slides();
        return s.length > 1 ? s[1].offsetLeft - s[0].offsetLeft : track.clientWidth;
      }
      function pages() {
        var st = step();
        return st > 0 ? Math.max(1, Math.round((track.scrollWidth - track.clientWidth) / st) + 1) : 1;
      }
      function index() {
        var st = step();
        return st > 0 ? Math.round(track.scrollLeft / st) : 0;
      }
      function go(i, wrap) {
        var n = pages();
        if (i < 0) i = (loop || wrap) ? n - 1 : 0;
        if (i > n - 1) i = (loop || wrap) ? 0 : n - 1;
        track.scrollTo({ left: i * step(), behavior: 'smooth' });
      }
      function update() {
        var can = scrollable();
        if (section) section.classList.toggle('svtp--scrollable', can);
        var i = index();
        var n = pages();
        if (dots) {
          for (var k = 0; k < dots.children.length; k++) {
            dots.children[k].classList.toggle('is-active', k === i);
            dots.children[k].setAttribute('aria-current', k === i ? 'true' : 'false');
          }
        }
        if (prev) prev.disabled = !loop && i <= 0;
        if (next) next.disabled = !loop && i >= n - 1;
      }
      function build() {
        if (dots) {
          var n = scrollable() ? pages() : 0;
          if (dots.children.length !== n) {
            dots.innerHTML = '';
            for (var i = 0; i < n; i++) {
              var b = document.createElement('button');
              b.type = 'button';
              b.className = 'svtp__dot';
              b.setAttribute('aria-label', 'Ir a la opinión ' + (i + 1));
              (function (j) { b.addEventListener('click', function () { go(j); restart(); }); })(i);
              dots.appendChild(b);
            }
          }
        }
        update();
      }
      function tick() {
        if (paused || !scrollable()) return;
        go(index() + 1, true);
      }
      function restart() {
        if (!auto) return;
        clearInterval(timer);
        timer = setInterval(tick, ms);
      }

      if (prev) prev.addEventListener('click', function () { go(index() - 1); restart(); });
      if (next) next.addEventListener('click', function () { go(index() + 1); restart(); });
      track.addEventListener('scroll', function () { clearTimeout(scrollT); scrollT = setTimeout(update, 80); }, { passive: true });
      window.addEventListener('resize', build);
      root.addEventListener('mouseenter', function () { paused = true; });
      root.addEventListener('mouseleave', function () { paused = false; });
      root.addEventListener('focusin', function () { paused = true; });
      root.addEventListener('focusout', function () { paused = false; });
      track.addEventListener('touchstart', function () { paused = true; }, { passive: true });
      track.addEventListener('touchend', function () { paused = false; restart(); }, { passive: true });

      build();
      restart();
    }
    function initAll(scope) {
      (scope || document).querySelectorAll('.svtp__slider').forEach(init);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sv-opiniones-trustpilot"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.svtpReady) return;
      root.dataset.svtpReady = '1';
      var section = root.closest('.svtp');
      var track = root.querySelector('.svtp__track');
      if (!track) return;
      var dots = root.querySelector('.svtp__dots');
      var prev = root.querySelector('.svtp__prev');
      var next = root.querySelector('.svtp__next');
      var loop = root.dataset.loop === 'true';
      var auto = root.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var ms = Math.max(1, parseFloat(root.dataset.speed) || 5) * 1000;
      var timer = null;
      var paused = false;
      var scrollT = null;

      function slides() { return track.children; }
      function scrollable() {
        return getComputedStyle(track).display === 'flex' && track.scrollWidth > track.clientWidth + 2;
      }
      function step() {
        var s = slides();
        return s.length > 1 ? s[1].offsetLeft - s[0].offsetLeft : track.clientWidth;
      }
      function pages() {
        var st = step();
        return st > 0 ? Math.max(1, Math.round((track.scrollWidth - track.clientWidth) / st) + 1) : 1;
      }
      function index() {
        var st = step();
        return st > 0 ? Math.round(track.scrollLeft / st) : 0;
      }
      function go(i, wrap) {
        var n = pages();
        if (i < 0) i = (loop || wrap) ? n - 1 : 0;
        if (i > n - 1) i = (loop || wrap) ? 0 : n - 1;
        track.scrollTo({ left: i * step(), behavior: 'smooth' });
      }
      function update() {
        var can = scrollable();
        if (section) section.classList.toggle('svtp--scrollable', can);
        var i = index();
        var n = pages();
        if (dots) {
          for (var k = 0; k < dots.children.length; k++) {
            dots.children[k].classList.toggle('is-active', k === i);
            dots.children[k].setAttribute('aria-current', k === i ? 'true' : 'false');
          }
        }
        if (prev) prev.disabled = !loop && i <= 0;
        if (next) next.disabled = !loop && i >= n - 1;
      }
      function build() {
        if (dots) {
          var n = scrollable() ? pages() : 0;
          if (dots.children.length !== n) {
            dots.innerHTML = '';
            for (var i = 0; i < n; i++) {
              var b = document.createElement('button');
              b.type = 'button';
              b.className = 'svtp__dot';
              b.setAttribute('aria-label', 'Ir a la opinión ' + (i + 1));
              (function (j) { b.addEventListener('click', function () { go(j); restart(); }); })(i);
              dots.appendChild(b);
            }
          }
        }
        update();
      }
      function tick() {
        if (paused || !scrollable()) return;
        go(index() + 1, true);
      }
      function restart() {
        if (!auto) return;
        clearInterval(timer);
        timer = setInterval(tick, ms);
      }

      if (prev) prev.addEventListener('click', function () { go(index() - 1); restart(); });
      if (next) next.addEventListener('click', function () { go(index() + 1); restart(); });
      track.addEventListener('scroll', function () { clearTimeout(scrollT); scrollT = setTimeout(update, 80); }, { passive: true });
      window.addEventListener('resize', build);
      root.addEventListener('mouseenter', function () { paused = true; });
      root.addEventListener('mouseleave', function () { paused = false; });
      root.addEventListener('focusin', function () { paused = true; });
      root.addEventListener('focusout', function () { paused = false; });
      track.addEventListener('touchstart', function () { paused = true; }, { passive: true });
      track.addEventListener('touchend', function () { paused = false; restart(); }, { passive: true });

      build();
      restart();
    }
    function initAll(scope) {
      (scope || document).querySelectorAll('.svtp__slider').forEach(init);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
